export const AUTH_LIFT_TO_MEMORY = 'Dock:authLiftToMemory';
export class InMemoryLocalWebStorage {
    constructor(prefix) {
        this.prefix = prefix;
        this.data = {};
        this.store = localStorage;
        this.isInMemory = false;
        this.abortController = new AbortController();
        window.addEventListener(AUTH_LIFT_TO_MEMORY, () => {
            this.liftToMemory();
        }, { signal: this.abortController.signal });
    }
    destroy() {
        this.abortController.abort();
    }
    clear() {
        if (this.isInMemory) {
            this.data = {};
            return;
        }
        this.store.clear();
    }
    getItem(key) {
        if (this.isInMemory) {
            return this.data[key];
        }
        return this.store.getItem(key);
    }
    setItem(key, value) {
        if (this.isInMemory) {
            this.data[key] = value;
        }
        else {
            this.store.setItem(key, value);
        }
    }
    removeItem(key) {
        if (this.isInMemory) {
            delete this.data[key];
        }
        else {
            this.store.removeItem(key);
        }
    }
    get length() {
        if (this.isInMemory) {
            return Object.getOwnPropertyNames(this.data).length;
        }
        return this.store.length;
    }
    key(index) {
        if (this.isInMemory) {
            return Object.getOwnPropertyNames(this.data)[index];
        }
        return this.store.key(index);
    }
    liftToMemory() {
        if (this.isInMemory) {
            return;
        }
        const keys = this.getAllKeys();
        keys.forEach((key) => {
            const prefixedKey = this.prefix + key;
            this.data[prefixedKey] = this.getItem(prefixedKey);
            this.removeItem(prefixedKey);
        });
        this.isInMemory = true;
    }
    getAllKeys() {
        const len = this.store.length;
        const keys = [];
        for (let index = 0; index < len; index++) {
            const key = this.store.key(index);
            if (key && key.indexOf(this.prefix) === 0) {
                keys.push(key.substring(this.prefix.length));
            }
        }
        return keys;
    }
}
//# sourceMappingURL=local-memory-storage.js.map